

















































import Vue                                           from 'vue'
import {Component}                                   from 'vue-property-decorator'
import Datatable                                     from '@/components/Datatable.vue'
import Box                                           from '@/components/Box.vue'
import CustomSelect                                  from '@/components/CustomSelect.vue'
import InputPeriod                                   from '@/components/InputPeriod.vue'
import CustomButton                                  from '@/components/CustomButton.vue'
import Navbar                                        from '@/components/Navbar.vue'
import {Account, Column, Dictionary, Invoice, Payer} from '@/types'
import {currency, dateFormat}                        from '@/common/helpers'
import printIcon                                     from '@/assets/img/print-solid.svg'
import SVGIcon                                       from '@/components/SVGIcon.vue'
import {
    invoices as getInvoices,
    accounts as getAccounts, currentPayer
}                                                    from '@/common/api'
import {document}                                    from '@/common/helpers'

interface Situation {
    label: string,
    value: string,
    private?: boolean
}

const columns: Column[] = [
    {
        title: 'Empresa',
        field: 'accountName',
        class: 'nowrap'
    },
    {
        title: 'Vencimento',
        field: 'dueDate',
        render(d) {
            return dateFormat(d, 'd/m/Y')
        }
    },
    {
        title: 'Situação',
        field: 'status',
        render(status) {
            const situation = situations.find((s) => s.value === status)
            return situation && situation.label
        }
    },
    {
        title: 'Valor (R$)',
        field: 'amount',
        class: 'right nowrap',
        render: currency
    }
]

const situations: Situation[] = [
    {
        value: 'generating',
        label: 'Emitindo',
        private: true
    },
    {
        value: 'opened',
        label: 'A vencer'
    },
    {
        value: 'overdue',
        label: 'Vencido'
    },
    {
        value: 'paid',
        label: 'Liquidado'
    },
    {
        value: 'pending',
        label: 'Em liquidação',
        private: true
    },
    {
        value: 'canceled',
        label: 'Cancelado'
    },
    {
        value: 'canceling',
        label: 'Cancelando',
        private: true
    }
]

@Component({
    components: {SVGIcon, Navbar, CustomButton, InputPeriod, CustomSelect, Box, Datatable}
})
export default class Home extends Vue {
    protected columns: Column[] = columns
    protected situations: Situation[] = situations
    protected printIcon: string = printIcon
    protected payer: Payer = {} as Payer
    protected accounts: Account[] = []
    protected invoices: Invoice[] = []
    protected hasMoreResults: boolean = true
    protected filters: Dictionary = {
        page: 1,
        perPage: 25
    }

    protected get name() {
        const {name, nickname} = this.payer
        const result = nickname || name
        if (!result) {
            return ''
        }
        if (result.length < 20) {
            return nickname
        }
        const [firstName, secondName] = result.split(' ')
        return `${firstName} ${secondName || ''}`.trim()
    }

    protected get document() {
        return document(this.payer.document)
    }

    protected get publicSituations(): Situation[] {
        return situations.filter((s: Situation) => !s.private)
    }

    protected async loadAccounts() {
        try {
            this.accounts = await getAccounts()
        } catch ({message}) {
            this.$msgError('Erro', message)
        }
    }

    protected async loadInvoices(e?: Event) {
        if (e) {
            e.preventDefault()
            this.invoices = []
            this.filters.page = 1
            this.hasMoreResults = true
        }

        if (!this.hasMoreResults) {
            return
        }

        try {
            const invoices = await getInvoices({...this.filters})

            this.hasMoreResults = !!invoices.length

            this.invoices = [
                ...this.invoices,
                ...invoices
            ]
        } catch ({message}) {
            this.$msgError('Erro', message)
        }
    }

    protected async lastPage(loading: (a: boolean) => void) {
        loading(true)
        this.filters.page += 1
        await this.loadInvoices()
        loading(false)
    }

    protected async mounted() {
        this.loadAccounts()
        this.loadInvoices()
        this.payer = currentPayer() || {} as Payer
    }
}
